import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ResetRequest() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/auth/reset-request", { email }); toast.success("If that email exists, a reset link has been sent."); }
    catch { toast.error("Something went wrong."); }
    setBusy(false);
  };
  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="reset-request-page">
      <h1 className="font-heading text-4xl mb-2">Reset password.</h1>
      <p className="text-neutral-600 mb-8">Enter your email and we'll send you a reset link.</p>
      <form onSubmit={submit} className="space-y-4">
        <Input type="email" placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)} required data-testid="reset-email" className="rounded-xl" />
        <Button type="submit" disabled={busy} className="w-full rounded-full bg-black text-white btn-pill" data-testid="reset-submit">{busy ? "Sending…" : "Send reset link"}</Button>
      </form>
    </div>
  );
}
